<template>
  <div>
    <div class="mb-4">
      <h4 class="mt-0 mb-0 font-weight-bold text-dark">Pending Payment</h4>
      <b-card-text>Pay your tuition fees with QR code.</b-card-text>
    </div>
    <div v-if="items.length != 0" class="row">
      <div
        v-for="(billItem, index) in items"
        :key="'bill' + index"
        class="col-md-6 col-lg-4 col-xl-4 col-sm-12 col-sm-12"
      >
        <b-card
          v-for="(billDetail, a) in billItem.detail"
          :key="'Detail' + a"
          no-body
          class="card-payment"
        >
          <b-card-body>
            <b-card-title class="mt-2 font-weight-bold"
              ><div class="text-center">
                <img
                  class="img-fluid img-responsive"
                  src="@/assets/img/logo_muic.png"
                  style="height: 70px"
                  alt="image-logo"
                /></div
            ></b-card-title>
            <!-- qr image -->
            <div v-if="billItem.status !== 'paid'" class="mb-4 mt-3">
              <div class="text-center mb-0">
                <img
                  style="width: 100%"
                  src="@/assets/img/pay/qrHeader.png"
                  alt=""
                />
                <b-img
                  style="width: 150px; height: 150px; margin-top: -30px"
                  center
                  fluid
                  :src="ImageQrPayment(billDetail.qrimage)"
                  alt="Center image"
                ></b-img>
              </div>
            </div>
            <div v-else class="mt-4 mb-5 text-center">
              <i
                class="text-success fa fa-check-square-o fa-5x"
                aria-hidden="true"
              />
            </div>
            <b-card-text>
              <b-list-group flush>
                <b-list-group-item>
                  <b-card-text class="text-uppercase font-weight-bold mb-1">{{
                    billItem.bill_type_detail.appname
                  }}</b-card-text>
                  <b-card-text class="text-muted mb-1 f-14">
                    {{ billItem.bill_type_detail.appdetail }}
                  </b-card-text>
                  <b-card-text class="text-muted mb-0 f-12">
                    Ref 1 : {{ billItem.ref_1 }}
                  </b-card-text>
                  <b-card-text class="text-muted mb-0 f-12">
                    Ref 2 : {{ billItem.ref_2 }}
                  </b-card-text>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="w-100 d-flex justify-content-between">
                    <div class="text-left">
                      <b-card-sub-title class="text-capitalize"
                        >Status</b-card-sub-title
                      >
                    </div>
                    <div class="text-right">
                      <b-badge
                        class="f-16 font-weight-bold text-capitalize"
                        :variant="
                          billItem.status === 'paid' ? 'success' : 'primary'
                        "
                        >{{ billItem.status === 'creating' ? 'Awaiting' : billItem.status }}</b-badge
                      >
                    </div>
                  </div>
                </b-list-group-item>
                <div v-if="billItem.status === 'paid'">
                  <b-list-group-item>
                    <div class="w-100 d-flex justify-content-between">
                      <div class="text-left">
                        <b-card-sub-title class="text-capitalize"
                          >Receipt ID</b-card-sub-title
                        >
                      </div>
                      <div class="text-right">
                        <b-card-title class="mt-2 mb-2 font-weight-bold f-16">
                          {{ billItem.receipt_id }}
                        </b-card-title>
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item>
                    <div class="w-100 d-flex justify-content-between">
                      <div class="text-left">
                        <b-card-sub-title class="text-capitalize"
                          >Payer name</b-card-sub-title
                        >
                      </div>
                      <div class="text-right">
                        <b-card-title class="mt-2 mb-2 f-16 font-slip-th">
                          {{ billDetail.payer_name }}
                        </b-card-title>
                      </div>
                    </div>
                    <div class="mt-2 mb-1">
                      <div class="text-left">
                        <b-card-sub-title class="text-capitalize"
                          >Sending Bank</b-card-sub-title
                        >
                      </div>
                      <div class="text-right">
                        <b-card-title class="mt-2 mb-2 f-12 font-slip-th">
                          {{ billDetail.sending_bank }}
                        </b-card-title>
                      </div>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item>
                    <div class="w-100 d-flex justify-content-between">
                      <div class="text-left">
                        <b-card-sub-title class="text-capitalize"
                          >Transaction Timestamp</b-card-sub-title
                        >
                      </div>
                      <div class="text-right">
                        <b-card-title class="mt-2 mb-2 font-weight-bold f-16">
                          <p class="mt-0 mb-0">
                            {{
                              moment(billDetail.transaction_date_time).format(
                                "DD/MM/YYYY"
                              )
                            }}
                          </p>
                          <p class="mt-0 mb-0 f-12">
                            {{
                              moment(billDetail.transaction_date_time).format(
                                "LT"
                              )
                            }}
                          </p>
                        </b-card-title>
                      </div>
                    </div>
                  </b-list-group-item>
                </div>
                <div v-else>
                  <b-list-group-item>
                    <div class="w-100 d-flex justify-content-between">
                      <div class="text-left">
                        <b-card-sub-title class="text-capitalize"
                          >Payment deadline</b-card-sub-title
                        >
                      </div>
                      <div class="text-right">
                        <b-card-title class="mt-2 mb-2 font-weight-bold f-16">
                          {{ moment(billDetail.exprie).format("DD/MM/YYYY") }}
                        </b-card-title>
                      </div>
                    </div>
                  </b-list-group-item>
                </div>
                <b-list-group-item>
                  <div
                    v-if="billItem.status !== 'paid'"
                    class="w-100 d-flex justify-content-between"
                  >
                    <div class="text-left">
                      <b-card-sub-title class="text-capitalize"
                        >Amount to be paid</b-card-sub-title
                      >
                    </div>
                    <div class="text-right">
                      <b-card-title class="mt-2 mb-0 font-weight-bold"
                        ><span class="f-28"
                          >฿ {{ numberWithCommas(billDetail.price) }}</span
                        ></b-card-title
                      >
                      <b-card-sub-title class="text-capitalize"
                        >Baht</b-card-sub-title
                      >
                    </div>
                  </div>
                  <div
                    v-if="billItem.status === 'paid'"
                    class="w-100 d-flex justify-content-between"
                  >
                    <div class="text-left">
                      <b-card-sub-title class="text-capitalize"
                        >Paid Amount</b-card-sub-title
                      >
                    </div>
                    <div class="text-right">
                      <b-card-title class="mt-2 mb-0 font-weight-bold"
                        ><span class="f-28"
                          >฿
                          {{ numberWithCommas(billDetail.payer_amount) }}</span
                        ></b-card-title
                      >
                      <b-card-sub-title class="text-capitalize"
                        >Baht</b-card-sub-title
                      >
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-card-text>
          </b-card-body>
          <template #footer v-if="billItem.status !== 'paid'">
            <div class="text-center">
              <b-button
                v-b-tooltip.hover
                :title="tooltipText"
                @click="getBillMe"
                class="text-primary"
                variant="link"
                >Check payment</b-button
              >
            </div>
          </template>
        </b-card>
      </div>
    </div>
    <div v-else>
      <b-alert show>
        <div class="text-center">
          <h5 class="mt-0 mb-0 font-weight-bold">You don't have any bills to pay.</h5>
        </div>
      </b-alert>
      <!-- <b-jumbotron>
        <template #lead>
          <b-media>
            <template #aside>
              <img style="width:150px;" class="mb-3 mt-0 img-fluid" src="@/assets/img/secure-server.png" alt="MUIC">
            </template>
            <h4 class="mt-3 mb-0">Sorry, our QR payment service is currently unavailable due to network connectivity issues.</h4>
            <h5 class="mb-0">Please come back and try again on <span class="text-danger font-weight-bold">Thursday, September 23, 2021 after 8:00AM</span>.</h5>
          </b-media>
        </template>
      </b-jumbotron> -->
    </div>
  </div>
</template>

<script>
// import Cardqr from "./cardQr";
export default {
  // components: {
  //   Cardqr,
  // },
  data() {
    return {
      tooltipText:
        "Once the payment has been made, you can click to view your information updates at this button.",
      fields: [
        {
          sortable: true,
          key: "Detail",
          label: "Bill",
          class: "text-center",
          thStyle: {
            width: "27%",
          },
        },
        {
          sortable: true,
          key: "status",
          label: "status",
          class: "text-center",
          thStyle: {
            width: "10%",
          },
        },
        {
          sortable: true,
          key: "paidBy",
          label: "Paid By",
          class: "text-left",
        },
      ],
      items: [],
    };
  },
  mounted() {
    this.getBillMe();
  },
  methods: {
    ImageQrPayment(val) {
      return val !== null ? `data:image/jpg;base64,${val}` : null;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async getBillMe() {
      this.items = [];
      try {
        const res = await this.$http.get("/ic-payment/me/");
        if (res.status === 200) {
          this.items = res.data.map((item) => {
            return {
              id: item.id,
              ref_1: item.ref_1,
              ref_2: item.ref_2,
              qrimage: item.qrcode,
              price: item.sum_price,
              exprie: item.expire_date,
              detail: [
                {
                  id: item.id,
                  bill_onwer_detail: item.bill_onwer_detail,
                  bill_mail: item.bill_mail,
                  ref_1: item.ref_1,
                  ref_2: item.ref_2,
                  update_at: item.update_at,
                  payer_account: item.payee_account_number,
                  payer_amount: item.payer_amount,
                  payer_name: item.payer_name,
                  sending_bank: item.sending_bank,
                  receiving_bank: item.receiving_bank,
                  transaction_date_time: item.transaction_date_time,
                  transaction_time: item.transaction_time,
                  qrimage: item.qrcode,
                  price: item.sum_price,
                  exprie: item.expire_date,
                },
              ],
              status: item.status,
              update_at: item.update_at,
              created_at: item.created_at,
              bill_type: item.bill_type,
              creator: item.creator,
              receipt_id: item.receipt_id,
              bill_type_detail:
                item.bill_type_detail !== null ? item.bill_type_detail : null,
            };
          });
        } else {
          throw { res };
        }
      } catch (error) {
        this.msgerror = "Problem !!";
      }
    },
  },
};
</script>

<style scoped>
.font-slip-th {
  font-family: "Kanit", sans-serif;
  font-weight: 100;
}
.alert-success {
  background-color: #ccffe8;
  color: #000000;
}
.f-14 {
  font-size: 14px;
}
.f-12 {
  font-size: 12px;
}
.f-16 {
  font-size: 16px;
}
.f-28 {
  font-size: 28px;
}
.card-payment {
  background-color: #fff;
  border-radius: 7px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.alert-info {
    background-color: #daf8ff;
    color: #4b96af;
}
.font-title-500{
  font-size: 18px;
}
</style>
